const initialContentState = {
  entry: {
    uid: "blt803a0dbe0b364eb5",
    _version: 4,
    locale: "en-us",
    ACL: {},
    _in_progress: false,
    blocks: [
      {
        block: {
          alias: "Loyalty Activity Content",
          _metadata: {
            uid: "cs049a6e9d250fe433",
          },
          render: [],
          configuration: [],
          section_background: [],
          content: [
            {
              _content_type_uid: "loy_activity",
              uid: "blt8bf1cc78d491d6d1",
              title: "Loyalty Activity Content",
              page_headline: "Mileage Activity",
              table_headers: [
                {
                  header_data: {
                    header_title: "Date",
                    order: "0",
                  },
                  _metadata: {
                    uid: "csb804a7f732ea820e",
                  },
                },
                {
                  header_data: {
                    header_title: "Activity",
                    order: "1",
                  },
                  _metadata: {
                    uid: "cs0c39c470be41d09d",
                  },
                },
                {
                  header_data: {
                    header_title: "Status",
                    order: "2",
                  },
                  _metadata: {
                    uid: "cs8f796e58451c36ec",
                  },
                },
                {
                  header_data: {
                    header_title: "Points",
                    order: "3",
                  },
                  _metadata: {
                    uid: "csac1f1e929bb4576f",
                  },
                },
                {
                  header_data: {
                    header_title: "Bonus Points",
                    order: "4",
                  },
                  _metadata: {
                    uid: "csd384aca49b50f471",
                  },
                },
                {
                  header_data: {
                    header_title: "Status Points",
                    order: "6",
                  },
                  _metadata: {
                    uid: "cs844d25f72e98e9f2",
                  },
                },
                {
                  header_data: {
                    header_title: "Total Points",
                    order: "5",
                  },
                  _metadata: {
                    uid: "cs844d25f72e98e9f1",
                  },
                },
              ],
              currency: "",
              currency_balance_label: "",
              currency_request_link: {
                title: "Request mileage credit",
                href: "https://www.alaskaair.com/MileagePlan/retrocredit/v1/",
              },
              filter_options: {
                filter_headline: "Filter Results By",
                activity: ["Air", "Car", "Financial Partners", "Hotel", "Other"],
                time: ["Past 3 months", "Past 6 months", "Past 12 months", "Past 24 months"],
                clear_filter_button: "Clear Filter",
                apply_filter_button: "Apply Filter",
              },
              fraud_alert_message: {
                type: "doc",
                uid: "e2a8c74180ea40eba47287371c94cd99",
                attrs: {},
                children: [
                  {
                    type: "p",
                    attrs: {},
                    uid: "97e293bebd26463195eefaa3fa7bc0ad",
                    children: [
                      {
                        text: "Loyalty Program Discrepancies",
                      },
                      {
                        text: "\n",
                        break: true,
                      },
                      {
                        text: "The Loyalty program account has some discrepancies. Contact Customer Care for assistance at 1-800-654-5669, Monday-Friday 7:00 a.m. - 7:00 p.m. (PT) and Saturday 8:00 a.m. - 5:00 p.m. (PT)",
                      },
                    ],
                  },
                ],
                _version: 14,
              },
              activity_fallback_message: {
                type: "doc",
                attrs: {},
                uid: "18c1a527a6384fd1b9026bb4eee96ca9",
                children: [
                  {
                    type: "p",
                    attrs: {},
                    uid: "220b2e0e14594e4286631ed73a6857e8",
                    children: [
                      {
                        text: "No Mileage Plan™ activity to display. Explore ways to earn and use",
                      },
                      {
                        uid: "8d3eac287d4f4d2a9a154f2dc6196919",
                        type: "a",
                        attrs: {
                          url: "https://www.alaskaair.com/content/mileage-plan/contact-mileage-plan",
                          target: "_self",
                        },
                        children: [
                          {
                            text: " Mileage Plan miles",
                          },
                        ],
                      },
                      {
                        text: ".",
                      },
                    ],
                  },
                ],
                _version: 3,
              },
              activity_disclaimer_message: {
                type: "doc",
                attrs: {},
                uid: "c70e2a52d44d49799e7c3e6fe0b0f8ac",
                children: [
                  {
                    type: "p",
                    attrs: {},
                    uid: "7557aae55e72478ab23a45bdf5c98b5c",
                    children: [
                      {
                        text: "Depending on the partnership, activity will appear on your account up to 60 days after you have earned miles. If you do not see activity after 60 days, ",
                      },
                      {
                        uid: "a00e8898e4244516934be8fc5a278ca9",
                        type: "a",
                        attrs: {
                          url: "https://www.alaskaair.com/content/mileage-plan/contact-mileage-plan",
                        },
                        children: [
                          {
                            text: "contact Mileage Plan",
                          },
                        ],
                      },
                      {
                        text: ".",
                      },
                    ],
                  },
                ],
                _version: 3,
              },
              tags: [],
              locale: "en-us",
              load_failure_error_message:
                "Sorry, we were unable to load your information at this time. Please try again later.",
              created_by: "blt478cceb82d98b48a",
              updated_by: "blt478cceb82d98b48a",
              created_at: "2025-04-07T22:57:21.461Z",
              updated_at: "2025-04-07T22:58:19.092Z",
              ACL: {},
              _version: 3,
              _in_progress: false,
              publish_details: {
                time: "2025-04-07T23:02:09.997Z",
                user: "blt478cceb82d98b48a",
                environment: "bltb81fa26ecfe6754c",
                locale: "en-us",
              },
            },
          ],
          offer_orchestration: false,
          optimizely_flags: {},
        },
      },
    ],
    created_at: "2025-04-07T22:59:17.685Z",
    created_by: "blt478cceb82d98b48a",
    head_metadata: [],
    navigation: {
      side_navigation: [],
      breadcrumbs: {
        breadcrumb: [
          {
            title: "Home",
            href: "https://www.alaskaair.com",
          },
          {
            title: "Account overview",
            href: "https://www.alaskaair.com/account/overview",
          },
          {
            title: "Mileage activity",
            href: "",
          },
        ],
      },
      anchors: {
        anchor: [],
      },
    },
    tags: [],
    title: "loyalty_activity_page",
    updated_at: "2025-04-07T23:02:02.620Z",
    updated_by: "blt478cceb82d98b48a",
    url: "/loyalty_activity_page",
    publish_details: {
      time: "2025-04-07T23:02:09.822Z",
      user: "blt478cceb82d98b48a",
      environment: "bltb81fa26ecfe6754c",
      locale: "en-us",
    },
    _embedded_items: {},
  },
};

type Block = {
  type: string;
  attrs: {};
  uid: string;
  children: [
    {
      type: string;
      attrs: {};
      uid: string;
      children: [
        {
          text: string;
        },
        {
          uid: string;
          type: string;
          attrs: {
            url: string;
          };
          children: [
            {
              text: string;
            },
          ];
        },
        {
          text: string;
        },
      ];
    },
  ];
  _version: 3;
};

export type ContentStateType = typeof initialContentState;
export type { Block };

export default initialContentState;
